import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import GameLogic from "@bd-core/game-logic";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";

export class StorePage extends BD_Component {
    constructor() {
        super();

        this.id = "store-page";
        this.template = "store-page-template";

        this.classes = {
            modalOpen: "modal--is-open",
            extraTypeRace: "is-race",
            extraTypeQuiz: "is-quiz",
            extraTypeQuestions: "is-questions",
            extraTypeStatement: "is-statement",
            /** All extra-type modifier classes (for removeClass before addClass). */
            extraTypeAll: "is-race is-quiz is-questions",
            isActive: "is-active",
            isSectionActive: "is-section-active",
            isSectionFinished: "is-section-finished",
            isSectionChallenge: "is-section-challenge",
            sectionAll:
                "is-section-active is-section-finished is-section-challenge",
            isSelected: "is-selected",
            isUnavailable: "is-unavailable",
            playerAll: "is-selected is-unavailable",
            isUnstarted: "is-unstarted",
            stepAll: "is-active is-unstarted",
            isTemplate: "is-template",
            quizTimerLabelOutside: "is-quiz-timer-label-outside",
            /** Fullscreen activity CTA: show "Bevestigen" instead of "Doorgaan". */
            isAnswering: "is-answering",
            isCorrect: "is-correct",
            isIncorrect: "is-incorrect",
            isAnswered: "is-answered",
            sectionActive: "section-active",
            segmentTitle: "segment__title",
            segmentOption: "segment__option",
            segmentOptionContent: "segment__option__content",
            segmentOptionBullet: "segment__option__bullet",
            segmentOptionText: "segment__option__text",
            /** Third column in fullscreen activity (results). */
            sectionFinishedPanel: "section-finished",
            resultsQuiz: "results--quiz",
            pointsValue: "points-value",
            timeValue: "time-value",
            answersCorrect: "answers-correct",
            answersIncorrect: "answers-incorrect",
            answersText: "answers-text",
            modalSectionSubtitle: "modal__section__subtitle",
            modalSectionTitle: "modal__section__title",
        };

        const T = this.classes.isTemplate;
        const c = this.classes;
        const activityFullPopup = ".store-page__modal.activity-full-popup";

        this.elms = {
            app: ".app",
            storePage: ".store-page",
            backButton: ".store-page__back__button",
            purchaseButton: ".row__item__actions__purchase",
            openButton: ".row__item__actions__open",
            openDonationButton: ".row__popup__button",
            purchaseItemButton: ".modal__footer__button",
            startActivityButton: ".js-start-activity-button",
            donationModal: ".store-page__modal.donation-popup",
            donationModalInfo: ".store-page__modal.donation-popup .modal__info",
            donationInput: ".js-store-donation-input",
            donationSubmit: ".js-store-donation-submit",
            activityInfoModal: ".store-page__modal.activity-info-popup",
            confirmPurchaseModal: ".store-page__modal.confirm-purchase-popup",
            activityStartedModal: ".store-page__modal.activity-started-popup",
            activityFullModal: activityFullPopup,
            activityFullRoot: activityFullPopup,
            closeDonationModalButton: ".js-close-donation-modal",
            closeConfirmPurchaseModalButton: ".js-close-confirm-purchase-modal",
            storePageModal: ".store-page__modal",
            modalContent: ".modal__content",
            activityInfoTagLabel: ".modal__activity__tag > span",
            activityInfoTitle: ".modal__activity__title",
            activityInfoImageImg: ".modal__activity__image img",
            activityInfoDescription: ".modal__activity__description",
            activityInfoFooterPointsSpan: ".modal__footer__points span",
            confirmItem: ".modal__item",
            confirmItemTagLabel: ".modal__item__tag > span",
            confirmItemTitle: ".modal__item__title",
            confirmItemImageImg: ".modal__item__image img",
            confirmPointsSpan: ".modal__points span",
            attrStoreLevelIndex: "data-store-level-index",
            attrExtraIndex: "data-extra-index",
            attrQuestionIndex: "data-question-index",
            fullscreenBack: ".modal__header__back",
            fullscreenInfoTagLabel: ".modal__header__tag > span",
            fullscreenImage: ".modal__header__image img",
            fullscreenTitle: ".modal__header__title",
            fullscreenContinueButton: ".js-handle-activity-steps",
            modalSections: ".modal__sections",
            modalStep: ".modal__step",
            rowItemActions: ".row__item__actions",
            modalSectionActiveBody: `.modal__section.${c.sectionActive} .modal__section__body`,
            modalSectionSegment: ".modal__section__segment",
            segmentTextInputTemplate: `.segment-text-input.${T}`,
            segmentMultipleChoiceTemplate: `.segment-multiple-choice.${T}`,
            /** Exclude template segments (`.is-template`). */
            isTemplateSelector: `.${c.isTemplate}`,
            segmentMultipleChoice: ".segment-multiple-choice",
            segmentTitle: `.${c.segmentTitle}`,
            segmentTextareaField: ".segment__textarea",
            segmentOptions: ".segment__options",
            modalSectionSegmentTextInput: `${activityFullPopup} .modal__section__segment.segment-text-input:not(.${T})`,
            modalSectionSegmentTextInputTitle: `${activityFullPopup} .modal__section__segment.segment-text-input:not(.${T}) > h2.${c.segmentTitle}`,
            modalSectionSegmentMultipleChoice: `${activityFullPopup} .modal__section__segment.segment-multiple-choice:not(.${T})`,
            modalSectionSegmentMultipleChoiceTitle: `${activityFullPopup} .modal__section__segment.segment-multiple-choice:not(.${T}) > h2.${c.segmentTitle}`,
            segmentTextarea: `${activityFullPopup} .modal__section__body .segment-text-input:not(.${T}) .segment__textarea`,
            quizSegments: ".quiz-segments",
            quizSegmentOption: `${activityFullPopup} .${c.segmentOption}`,
            segmentOption: `.${c.segmentOption}`,
            segmentOptionSelected: `.${c.segmentOption}.${c.isSelected}`,
            playerGridItem: ".player-grid__item",
            playerGridItemSelected: `.player-grid__item.${c.isSelected}`,
            modalStepUnstarted: `.modal__step.${c.isUnstarted}`,
            modalProgressFill: ".modal__header__timer__progress__fill",
            modalProgressFillSpan: ".modal__header__timer__progress__fill span",
            modalProgressTrack: ".modal__header__timer__progress",
            playerIdDataKey: "player-id",
            activityFullSectionFinished: `${activityFullPopup} .${c.sectionFinishedPanel}`,
            quizResultsPointsValue: `.${c.resultsQuiz} .${c.pointsValue}`,
            quizResultsTimeValue: `.${c.resultsQuiz} .${c.timeValue}`,
            quizResultsAnswersCorrectText: `.${c.answersCorrect} .${c.answersText}`,
            quizResultsAnswersIncorrectText: `.${c.answersIncorrect} .${c.answersText}`,
            finishedSectionSubtitle: `.${c.modalSectionSubtitle}`,
            finishedSectionTitle: `.${c.modalSectionTitle}`,
            raceTimerTime: `${activityFullPopup} .race-timer__time`,
            raceResultsTime: `${activityFullPopup} .results--race__time`,
            /** Meta key on `_userAnswers` for quiz completion summary (not a DOM selector). */
            quizSummaryMetaKey: "__quizSummary",
            /** Meta key on `_userAnswers` for race completion summary (not a DOM selector). */
            raceSummaryMetaKey: "__raceSummary",
            modalTitleQuestions: "h3.modal__title.questions",
            modalTitleQuiz: "h3.modal__title.quiz",
            modalTitleRace: "h3.modal__title.race",
        };

        this._events = this.getEvents();
        this._teamId = null;
        this._storeLevels = [];
        this._userPoints = 0;
        this._donationLevelIndex = 0;
        this._donationSubmitting = false;
        this._teamMembers = [];
        /** @type {Record<string, unknown> | null} */
        this._selectedExtra = null;
        /** @type {number} Level row the user opened (extras may repeat across levels; drives buy_extras_store_{n}). */
        this._selectedStoreLevelIndex = 0;
        /** @type {ReturnType<typeof setInterval> | null} */
        this._quizTimerIntervalId = null;
        /** Total quiz duration in seconds (from `timer` minutes string). */
        this._quizTimerTotalSec = 0;
        /** Remaining seconds for the quiz countdown UI. */
        this._quizTimerRemainingSec = 0;
        /** @type {ReturnType<typeof setInterval> | null} */
        this._raceTimerIntervalId = null;
        /** Elapsed seconds for race count-up UI. */
        this._raceElapsedSec = 0;
        this._raceIndex = 0;
        this._quizIndex = 0;
        /**
         * Current activity payload: prompt string (`question`), question list (`quiz` / `race`), or `{}` when unset.
         * @type {unknown}
         */
        this._questions = {};
        this._userAnswers = {};
        /** Detached clone of `segmentMultipleChoiceTemplate` (without `isTemplate`) for rebuilding quiz UI. */
        this._quizMcTemplate = null;
        /** Detached clone of `segmentTextInputTemplate` for race essay segments. */
        this._raceTextTemplate = null;
        /** Detached clone of `segmentMultipleChoiceTemplate` for race MC segments. */
        this._raceMcTemplate = null;
    }

    getEvents() {
        const elms = this.elms;

        return [
            {
                selector: elms.backButton,
                event: "click",
                handler: this.handleBackButtonClick,
            },
            {
                selector: elms.purchaseButton,
                event: "click",
                handler: this.handlePurchaseButtonClick,
            },
            {
                selector: elms.openButton,
                event: "click",
                handler: this.handleOpenButtonClick,
            },
            {
                selector: elms.storePageModal,
                event: "click",
                handler: this.handleStoreModalBackdropClick,
            },
            {
                selector: elms.openDonationButton,
                event: "click",
                handler: this.openDonationModal,
            },
            {
                selector: elms.purchaseItemButton,
                event: "click",
                handler: this.openConfirmPurchaseModal,
            },
            {
                selector: elms.startActivityButton,
                event: "click",
                handler: this.startActivity,
            },
            {
                selector: elms.closeDonationModalButton,
                event: "click",
                handler: this.closeDonationModal,
            },
            {
                selector: elms.closeConfirmPurchaseModalButton,
                event: "click",
                handler: this.closeConfirmPurchaseModal,
            },
            {
                selector: elms.donationInput,
                event: "input",
                handler: this.onDonationInput,
            },
            {
                selector: elms.donationSubmit,
                event: "click",
                handler: this.submitDonation,
            },
            {
                selector: elms.fullscreenBack,
                event: "click",
                handler: this.closeActivityFullModal,
            },
            {
                selector: elms.fullscreenContinueButton,
                event: "click",
                handler: this.handleActivityStepsContinue,
            },
            {
                selector: elms.segmentTextarea,
                event: "input",
                handler: this.handleSegmentTextareaInput,
            },
            {
                selector: elms.playerGridItem,
                event: "click",
                handler: this.handlePlayerGridItemClick,
            },
            {
                selector: elms.quizSegmentOption,
                event: "click",
                handler: this.handleQuizSegmentOptionClick,
            },
        ];
    }

    beforeInit() {
        this._teamId = localStorage.getItem("teamId");
        this.render();
        this.setGameState();
    }

    async render() {
        const data = this._data;
        data.store_levels = await this.getStoreLevels();
        data.team_members = this._teamMembers;

        const htmlTemplate = $("#" + this.template).html();
        const html = compile(htmlTemplate, data);
        $(this.elms.app).html(html);
    }

    setGameState() {}

    beforeDestroy() {
        this.clearActivityTimers();
    }

    /**
     * Stops quiz countdown and race count-up (use on modal close / reset / destroy).
     */
    clearActivityTimers() {
        this.clearQuizCountdown();
        this.clearRaceCountUp();
    }

    /**
     * Active step body inside `.modal__sections` (the segment container for quiz/race/question UI).
     *
     * @returns {BD_JQuery}
     */
    getActiveModalBody() {
        return $(this.elms.modalSections).find(
            this.elms.modalSectionActiveBody,
        );
    }

    /**
     * One multiple-choice segment by `data-question-index` (quiz grading / race MC).
     *
     * @param {BD_JQuery} $body
     * @param {number} index
     * @returns {BD_JQuery}
     */
    findMultipleChoiceSegment($body, index) {
        const elms = this.elms;
        return $body.find(
            `${elms.segmentMultipleChoice}[${elms.attrQuestionIndex}="${index}"]`,
        );
    }

    /**
     * Appends MC `<li>` options; `data-id` must stay parseable by {@link parseQuizOptionAnswerIndex}.
     *
     * @param {BD_JQuery} $options
     * @param {object} opts
     * @param {string} opts.optionIdPrefix e.g. `quiz_option` or `race_option`
     * @param {number} opts.questionIndex
     * @param {unknown} opts.answers
     */
    appendMcOptionList($options, { optionIdPrefix, questionIndex, answers }) {
        const c = this.classes;
        if (!Array.isArray(answers)) {
            return;
        }
        answers.forEach((answer, i) => {
            const optionId = `${optionIdPrefix}_${questionIndex}_${i}`;
            const $opt = $(`
                        <li class="${c.segmentOption}" data-id="${optionId}">
                            <div class="${c.segmentOptionContent}">
                                <div class="${c.segmentOptionBullet}">
                                    <span>${String.fromCharCode(65 + i)}</span>
                                </div>
                                <span class="${c.segmentOptionText}">${String(answer.answer || "")}</span>
                            </div>
                        </li>
                    `);
            $options.append($opt);
        });
    }

    /**
     * Keep only digits so the amount is always a whole number (no commas or decimals).
     *
     * @param {BD_JQuery} $input
     */
    sanitizeDonationInput($input) {
        const raw = $input.val();
        const digits = String(raw ?? "").replace(/\D/g, "");
        if (digits !== raw) {
            $input.val(digits);
        }
    }

    onDonationInput(e) {
        this.sanitizeDonationInput($(e.currentTarget));
    }

    // ===== HANDLERS =====
    async getStoreLevels() {
        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-store", { teamId: this._teamId }),
        );

        const payload = res?.data?.data;
        const levels = Array.isArray(payload?.store_levels)
            ? payload.store_levels
            : Array.isArray(payload)
              ? payload
              : [];

        this._storeLevels = levels;
        this._userPoints = Number(payload?.user_points ?? 0) || 0;
        this._teamMembers = payload?.team_members ?? [];

        return levels;
    }

    handleBackButtonClick(e) {
        e.preventDefault();
        GameLogic.goToPage("home-page");
    }

    /**
     * @param {string | undefined} type
     * @returns {string}
     */
    extrasTypeClass(type) {
        const c = this.classes;
        switch (type) {
            case "race":
                return c.extraTypeRace;
            case "quiz":
                return c.extraTypeQuiz;
            case "question":
                return c.extraTypeQuestions;
            default:
                return c.extraTypeQuestions;
        }
    }

    /**
     * @param {string | undefined} type
     */
    formatTypeLabel(type) {
        return String(type ?? "").toUpperCase();
    }

    /**
     * @param {Record<string, unknown>} extra
     */
    populateActivityInfoModal(extra) {
        const elms = this.elms;
        const $m = $(elms.activityInfoModal);
        const typeClass = this.extrasTypeClass(
            /** @type {string | undefined} */ (extra.type),
        );
        $m.removeClass(this.classes.extraTypeAll).addClass(typeClass);
        $m.find(elms.activityInfoTagLabel).text(
            this.formatTypeLabel(
                /** @type {string | undefined} */ (extra.type),
            ),
        );
        $m.find(elms.activityInfoTitle).text(String(extra.title ?? ""));
        $m.find(elms.activityInfoImageImg)
            .attr("src", String(extra.image ?? ""))
            .attr("alt", String(extra.title ?? ""));
        const $desc = $m.find(elms.activityInfoDescription);
        const description = extra.description;
        if (description) {
            $desc.html(String(description));
        } else {
            $desc.empty().append($("<p></p>"));
        }
        $m.find(elms.activityInfoFooterPointsSpan).text(
            String(extra.price ?? ""),
        );
    }

    /**
     * @param {Record<string, unknown>} extra
     */
    populateConfirmPurchaseModal(extra) {
        const elms = this.elms;
        const $m = $(elms.confirmPurchaseModal);
        const typeClass = this.extrasTypeClass(
            /** @type {string | undefined} */ (extra.type),
        );
        $m.find(elms.confirmItem)
            .removeClass(this.classes.extraTypeAll)
            .addClass(typeClass);
        $m.find(elms.confirmItemTagLabel).text(
            this.formatTypeLabel(
                /** @type {string | undefined} */ (extra.type),
            ),
        );
        $m.find(elms.confirmItemTitle).text(String(extra.title ?? ""));
        $m.find(elms.confirmItemImageImg)
            .attr("src", String(extra.image ?? ""))
            .attr("alt", String(extra.title ?? ""));
        $m.find(elms.confirmPointsSpan).text(String(extra.price ?? ""));
    }

    handlePurchaseButtonClick(e, $actions) {
        e.preventDefault();
        const a = this.elms;
        const $parentActions = $actions.closest(a.rowItemActions);
        const levelIdx = parseInt(
            $parentActions.attr(a.attrStoreLevelIndex),
            10,
        );
        const extraIdx = parseInt($parentActions.attr(a.attrExtraIndex), 10);

        const level = this._storeLevels[levelIdx];
        const extra = level?.extras?.[extraIdx];
        if (!extra || typeof extra !== "object") {
            return;
        }
        this._selectedExtra = extra;
        this._selectedStoreLevelIndex = Number.isFinite(levelIdx)
            ? levelIdx
            : 0;
        this.populateActivityInfoModal(extra);
        $(this.elms.activityInfoModal).addClass(this.classes.modalOpen);
    }

    handleOpenButtonClick(e, $actions) {
        e.preventDefault();
        const a = this.elms;
        const $targetActions = $actions || $(e.currentTarget);
        const $parentActions = $targetActions.closest(a.rowItemActions);
        const levelIdx = parseInt(
            $parentActions.attr(a.attrStoreLevelIndex),
            10,
        );
        const extraIdx = parseInt($parentActions.attr(a.attrExtraIndex), 10);

        const level = this._storeLevels[levelIdx];
        const extra = level?.extras?.[extraIdx];
        if (!extra || typeof extra !== "object" || !extra.purchased) {
            return;
        }

        const pendingTimelineKey = "pendingHomeTimelineId";
        localStorage.removeItem(pendingTimelineKey);
        const timelineId = Number(extra.timeline_id) || 0;
        if (timelineId > 0) {
            localStorage.setItem(pendingTimelineKey, String(timelineId));
        }

        GameLogic.goToPage("home-page");
    }

    /**
     * @param {BD_JQueryEvent} e
     */
    handleStoreModalBackdropClick(e) {
        const $modal = $(e.currentTarget);
        if (!$modal.hasClass(this.classes.modalOpen)) {
            return;
        }
        if ($(e.target).closest(this.elms.modalContent).length) {
            return;
        }
        $modal.removeClass(this.classes.modalOpen);
    }

    openDonationModal(e) {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const idx = parseInt($btn.attr(this.elms.attrStoreLevelIndex), 10);
        this._donationLevelIndex = Number.isFinite(idx) ? idx : 0;

        $(this.elms.donationModal).find(this.elms.donationInput).val("");
        $(this.elms.donationModal).addClass(this.classes.modalOpen);
    }

    openConfirmPurchaseModal(e) {
        e.preventDefault();
        if (this._selectedExtra) {
            this.populateConfirmPurchaseModal(this._selectedExtra);
        }
        let modalTitle = "";
        /** @type {BD_JQuery | null} */
        let $modalElms = null;
        const type = this._selectedExtra?.type;
        switch (type) {
            case "question":
                $modalElms = $(this.elms.modalTitleQuestions);
                modalTitle = $modalElms.text();
                break;
            case "quiz":
                $modalElms = $(this.elms.modalTitleQuiz);
                modalTitle = $modalElms.text();
                break;
            case "race":
                $modalElms = $(this.elms.modalTitleRace);
                modalTitle = $modalElms.text();
                break;
        }

        const typeLabel = typeof type === "string" ? type : "";
        const result = modalTitle.replace(/\{extra_type\}/g, typeLabel);
        if ($modalElms) {
            $modalElms.text(result);
        }

        $(this.elms.activityInfoModal).removeClass(this.classes.modalOpen);
        $(this.elms.confirmPurchaseModal).addClass(this.classes.modalOpen);
    }

    closeDonationModal(e) {
        e.preventDefault();
        $(this.elms.donationModal).removeClass(this.classes.modalOpen);
    }

    closeConfirmPurchaseModal(e) {
        e.preventDefault();
        $(this.elms.confirmPurchaseModal).removeClass(this.classes.modalOpen);
    }

    async submitDonation(e) {
        e.preventDefault();
        if (this._donationSubmitting) {
            return;
        }

        const $modal = $(this.elms.donationModal);
        const $input = $modal.find(this.elms.donationInput);
        this.sanitizeDonationInput($input);

        const amount = parseInt(String($input.val() ?? ""), 10) || 0;
        const level = this._storeLevels[this._donationLevelIndex];
        const need = Math.max(0, Number(level?.amount_to_donate ?? 0));
        const maxDonate = Math.min(need, this._userPoints);

        if (need <= 0) {
            alert("This level is already fully funded.");
            return;
        }
        if (this._userPoints <= 0) {
            alert("You do not have any points to donate.");
            return;
        }
        if (amount <= 0) {
            alert("Enter a valid whole number of GP.");
            return;
        }
        if (amount > maxDonate) {
            alert(
                maxDonate <= 0
                    ? "You cannot donate with your current balance and progress."
                    : `You can donate at most ${maxDonate} GP (capped by what the level still needs and your balance).`,
            );
            return;
        }

        this._donationSubmitting = true;

        const [res] = await bdjs.goAsync(
            bdapi.post("game/donate-store", {
                teamId: this._teamId,
                store_level_index: this._donationLevelIndex,
                amount,
            }),
        );

        this._donationSubmitting = false;

        if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
            return;
        }

        const payload = res?.data?.data;
        if (payload?.user_points != null) {
            this._userPoints = Number(payload.user_points) || 0;
        }

        $modal.removeClass(this.classes.modalOpen);
        await this.render();
    }

    startActivity(e) {
        e.preventDefault();

        const price = Number(this._selectedExtra?.price ?? 0) || 0;
        if (price > 0 && this._userPoints < price) {
            alert(
                `You do not have enough GP for this extra. You need ${price} GP and your balance is ${this._userPoints} GP.`,
            );
            return;
        }

        $(this.elms.confirmPurchaseModal).removeClass(this.classes.modalOpen);

        const elms = this.elms;
        const c = this.classes;
        $(elms.fullscreenContinueButton).removeClass(c.isAnswering);
        const $body = this.getActiveModalBody();
        $body
            .find(elms.modalSectionSegment)
            .not(elms.isTemplateSelector)
            .remove();

        const type = this._selectedExtra.type;
        switch (type) {
            case "question":
                this._questions = this._selectedExtra.question;
                {
                    const $tpl = $body
                        .find(elms.segmentTextInputTemplate)
                        .first();
                    if ($tpl.length) {
                        const $textSeg = $tpl
                            .clone(true, true)
                            .removeClass(c.isTemplate);
                        $textSeg
                            .find(elms.segmentTitle)
                            .text(String(this._questions ?? ""));
                        $textSeg.find(elms.segmentTextareaField).val("");
                        $textSeg.addClass(c.isActive);
                        $body.append($textSeg);
                    }
                }
                break;
            case "quiz": {
                this._quizIndex = 0;
                this._userAnswers = {};
                this._questions = this._selectedExtra.quiz_questions;
                this.populateQuizProgress(
                    String(this._selectedExtra.timer ?? ""),
                );
                const qLen = Array.isArray(this._questions)
                    ? this._questions.length
                    : 0;
                $(this.elms.quizSegments).html(
                    `<span><b>${this._quizIndex + 1}</b>/${qLen}</span>`,
                );
                this.populateQuizQuestion(this._questions);
                $(this.elms.fullscreenContinueButton)
                    .addClass(this.classes.isAnswering)
                    .prop("disabled", true);
                break;
            }
            case "race": {
                this._raceIndex = 0;
                this._userAnswers = {};
                this._questions = this._selectedExtra.race_questions;
                this.populateRaceQuestions(
                    Array.isArray(this._questions) ? this._questions : [],
                );
                this.clearRaceCountUp();
                this.startRaceCountUp();
                $(this.elms.fullscreenContinueButton)
                    .addClass(this.classes.isAnswering)
                    .prop("disabled", true);
                this.syncRaceBevestigenEnabled();
                break;
            }
            default:
                this._questions = {};
                break;
        }

        $(this.elms.activityFullModal)
            .removeClass(this.classes.extraTypeAll)
            .addClass(this.extrasTypeClass(/** @type {string} */ (type)));
        $(this.elms.fullscreenInfoTagLabel).text(
            this.formatTypeLabel(/** @type {string} */ (type)),
        );
        $(this.elms.fullscreenImage).attr(
            "src",
            String(this._selectedExtra.image ?? ""),
        );
        $(this.elms.fullscreenTitle).text(
            String(this._selectedExtra.title ?? ""),
        );

        $(this.elms.activityFullModal).addClass(this.classes.modalOpen);
    }

    closeActivityFullModal(e) {
        e.preventDefault();
        this.clearActivityTimers();
        this.resetActivityFlowState();
        this._quizIndex = 0;
        this._raceIndex = 0;
        this._userAnswers = {};
        $(this.elms.fullscreenContinueButton).removeClass(
            this.classes.isAnswering,
        );
        $(this.elms.activityFullModal).removeClass(this.classes.modalOpen);
    }

    /**
     * Reset fullscreen activity modal DOM and selection state to match initial markup.
     */
    resetActivityFlowState() {
        const elms = this.elms;
        const c = this.classes;

        $(elms.activityFullModal)
            .removeClass(c.modalOpen)
            .removeClass(c.extraTypeAll);

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionActive);

        $(elms.modalStep).each((i, stepEl) => {
            const $step = $(stepEl);
            $step.removeClass(c.stepAll);
            if (i === 0) {
                $step.addClass(c.isActive);
            } else {
                $step.addClass(c.isUnstarted);
            }
        });

        this.getActiveModalBody()
            .find(elms.modalSectionSegment)
            .not(elms.isTemplateSelector)
            .remove();
        this._quizMcTemplate = null;
        this._raceMcTemplate = null;
        this._raceTextTemplate = null;
        $(elms.playerGridItem).removeClass(c.playerAll);
        $(elms.fullscreenContinueButton)
            .removeClass(c.isAnswering)
            .prop("disabled", true);

        this.clearActivityTimers();
        this._quizIndex = 0;
        this._raceIndex = 0;
        this._userAnswers = {};
        this._selectedExtra = null;
        this._selectedStoreLevelIndex = 0;
    }

    handleActivityStepsContinue(e) {
        e.preventDefault();
        const type = this._selectedExtra.type;
        const c = this.classes;
        const $modalSections = $(this.elms.modalSections);

        if ($modalSections.hasClass(c.isSectionChallenge)) {
            this.finalizeActivityChallengeIfReady();
            return;
        }

        if (
            (type === "quiz" || type === "race") &&
            $modalSections.hasClass(c.isSectionFinished)
        ) {
            this.goToQuizChallengeSection();
            return;
        }

        this.handleActivityContinueMainFlow(
            /** @type {string | undefined} */ (type),
        );
    }

    /**
     * Challenge step: validate player (and free-text for `question`) then {@link finalizeChallenge}.
     */
    finalizeActivityChallengeIfReady() {
        const challengeType = this._selectedExtra.type;
        const textAnswer = String(
            $(this.elms.segmentTextarea).val() ?? "",
        ).trim();
        let selectedPlayerId = null;
        const $selectedPlayer = $(this.elms.playerGridItemSelected);
        if ($selectedPlayer.length) {
            selectedPlayerId = $selectedPlayer.data(this.elms.playerIdDataKey);
        }

        if (!selectedPlayerId) {
            alert(
                "There is something wrong with your answer or selected player.",
            );
            return;
        }
        if (
            challengeType !== "quiz" &&
            challengeType !== "race" &&
            !textAnswer
        ) {
            alert(
                "There is something wrong with your answer or selected player.",
            );
            return;
        }

        this.finalizeChallenge(
            challengeType === "quiz" || challengeType === "race"
                ? null
                : textAnswer,
            selectedPlayerId,
        );
    }

    /**
     * Intro / quiz / race step handling (not challenge, not finished → player assignment).
     *
     * @param {string | undefined} type
     */
    handleActivityContinueMainFlow(type) {
        switch (type) {
            case "question": {
                $(this.elms.modalSections)
                    .removeClass(this.classes.sectionAll)
                    .addClass(this.classes.isSectionChallenge);

                var $unstartedStep = $(this.elms.modalStepUnstarted).first();
                if ($unstartedStep.length) {
                    $unstartedStep
                        .removeClass(this.classes.isUnstarted)
                        .addClass(this.classes.isActive);
                }
                this.syncFullscreenChallengeContinueButton();
                break;
            }
            case "quiz":
                this.handleStoreQuizStepsContinue();
                break;
            case "race":
                this.handleRaceStepsContinue();
                break;
            default:
                break;
        }
    }

    /**
     * @param {string | null} answer Text for `question` extras; ignored for `quiz` / `race` (server gets `this._userAnswers` JSON).
     */
    async finalizeChallenge(answer, selectedPlayerId) {
        const extraType = this._selectedExtra.type;
        const answerPayload =
            extraType === "quiz" || extraType === "race"
                ? JSON.stringify(this._userAnswers)
                : String(answer ?? "");

        const [res] = await bdjs.goAsync(
            bdapi.post("game/finalize-challenge", {
                teamId: this._teamId,
                extraId: this._selectedExtra.id,
                answer: answerPayload,
                selectedPlayerId,
                type: extraType,
                storeLevelIndex: this._selectedStoreLevelIndex,
            }),
        );

        if (res?.data?.success === false && res?.data?.data?.message) {
            alert(res.data.data.message);
            return;
        }

        this.resetActivityFlowState();
        await this.getStoreLevels();
        await this.render();
    }

    handleSegmentTextareaInput(e) {
        e.preventDefault();
        const type = this._selectedExtra.type;
        const $input = $(e.currentTarget);
        const value = $input.val();
        const trimmedValue = String(value).trim();
        const inChallenge = $(this.elms.modalSections).hasClass(
            this.classes.isSectionChallenge,
        );
        switch (type) {
            case "question":
                if (inChallenge) {
                    this.syncFullscreenChallengeContinueButton();
                } else {
                    $(this.elms.fullscreenContinueButton).prop(
                        "disabled",
                        !(trimmedValue.length > 0),
                    );
                }
                break;
            case "quiz":
                if (inChallenge) {
                    this.syncFullscreenChallengeContinueButton();
                }
                break;
            case "race":
                if (inChallenge) {
                    this.syncFullscreenChallengeContinueButton();
                } else {
                    this.syncRaceBevestigenEnabled();
                }
                break;
            default:
                break;
        }
    }

    /**
     * Enables "Doorgaan" on the challenge step when requirements are met (player + optional text).
     */
    syncFullscreenChallengeContinueButton() {
        const elms = this.elms;
        const c = this.classes;
        if (!this._selectedExtra) {
            return;
        }
        if (!$(elms.modalSections).hasClass(c.isSectionChallenge)) {
            return;
        }

        const activityType = this._selectedExtra.type;
        const $btn = $(elms.fullscreenContinueButton);
        const hasPlayer = $(elms.playerGridItemSelected).length > 0;
        const hasText =
            String($(elms.segmentTextarea).val() ?? "").trim().length > 0;

        if (activityType === "quiz" || activityType === "race") {
            $btn.prop("disabled", !hasPlayer);
            return;
        }
        if (activityType === "question") {
            $btn.prop("disabled", !(hasText && hasPlayer));
        }
    }

    handlePlayerGridItemClick(e) {
        e.preventDefault();
        const $current = $(e.currentTarget);
        if ($current.hasClass(this.classes.isSelected)) return;

        $(this.elms.playerGridItem).removeClass(this.classes.playerAll);
        $current.addClass(this.classes.isSelected);
        this.syncFullscreenChallengeContinueButton();
    }

    handleQuizSegmentOptionClick(e) {
        e.preventDefault();
        const activityType = this._selectedExtra?.type;
        if (activityType !== "quiz" && activityType !== "race") {
            return;
        }
        const c = this.classes;
        const elms = this.elms;
        const $opt = $(e.currentTarget);
        const $segment = $opt.closest(elms.segmentMultipleChoice);
        if (!$segment.length) {
            return;
        }
        const segIdx = parseInt(
            $segment.attr(elms.attrQuestionIndex) ?? "",
            10,
        );
        const expectedIdx =
            activityType === "quiz" ? this._quizIndex : this._raceIndex;
        if (!Number.isFinite(segIdx) || segIdx !== expectedIdx) {
            return;
        }
        if ($segment.hasClass(c.isAnswered)) {
            return;
        }

        $opt.siblings(elms.segmentOption).removeClass(c.isSelected);
        $opt.addClass(c.isSelected);

        const $btn = $(elms.fullscreenContinueButton);
        if ($btn.hasClass(c.isAnswering)) {
            $btn.prop("disabled", false);
        }
        if (activityType === "race") {
            this.syncRaceBevestigenEnabled();
        }
    }

    /**
     * @param {unknown} answers
     * @returns {number}
     */
    getQuizCorrectAnswerIndex(answers) {
        if (!Array.isArray(answers)) {
            return -1;
        }
        return answers.findIndex(
            (a) =>
                a &&
                (a.is_correct === true ||
                    a.is_correct === 1 ||
                    a.is_correct === "1"),
        );
    }

    /**
     * @param {string | undefined} dataId e.g. `quiz_option_0_2`
     * @returns {number}
     */
    parseQuizOptionAnswerIndex(dataId) {
        const m = String(dataId ?? "").match(/_(\d+)$/);
        return m ? parseInt(m[1], 10) : -1;
    }

    handleStoreQuizStepsContinue() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }

        if ($btn.hasClass(c.isAnswering)) {
            this.gradeCurrentQuizQuestion();
            return;
        }

        if (this._quizIndex < questions.length - 1) {
            this._quizIndex += 1;
            const $body = this.getActiveModalBody();
            const $prev = this.findMultipleChoiceSegment(
                $body,
                this._quizIndex - 1,
            );
            const $next = this.findMultipleChoiceSegment(
                $body,
                this._quizIndex,
            );
            if ($prev.length) {
                $prev.removeClass(c.isActive);
            }
            $next.addClass(c.isActive);
            $(elms.quizSegments).html(
                `<span><b>${this._quizIndex + 1}</b>/${questions.length}</span>`,
            );
            $btn.addClass(c.isAnswering).prop("disabled", true);
            return;
        }

        this.showQuizFinishedSection();
    }

    goToQuizChallengeSection() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionChallenge);

        const $unstartedStep = $(elms.modalStepUnstarted).first();
        if ($unstartedStep.length) {
            $unstartedStep.removeClass(c.isUnstarted).addClass(c.isActive);
        }
        $btn.prop("disabled", true);
        this.syncFullscreenChallengeContinueButton();
    }

    /**
     * Sums points and counts correct/incorrect from graded question entries in `_userAnswers`.
     */
    getQuizSessionStats() {
        const metaKey = this.elms.quizSummaryMetaKey;
        let totalPoints = 0;
        let correctCount = 0;
        let incorrectCount = 0;
        for (const [key, raw] of Object.entries(this._userAnswers)) {
            if (key === metaKey || !raw || typeof raw !== "object") {
                continue;
            }
            const entry = /** @type {{ correct?: boolean, score?: number }} */ (
                raw
            );
            totalPoints += Math.max(0, Number(entry.score) || 0);
            if (entry.correct === true) {
                correctCount += 1;
            } else if (entry.correct === false) {
                incorrectCount += 1;
            }
        }
        return { totalPoints, correctCount, incorrectCount };
    }

    showQuizFinishedSection() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const totalSec = this._quizTimerTotalSec;
        const remaining = this._quizTimerRemainingSec;
        const completionTimeSec =
            totalSec > 0 ? Math.max(0, totalSec - remaining) : 0;

        this.stopQuizCountdownIntervalOnly();

        const { totalPoints, correctCount, incorrectCount } =
            this.getQuizSessionStats();

        const $finished = $(elms.activityFullSectionFinished);
        $finished.find(elms.quizResultsPointsValue).text(String(totalPoints));
        $finished
            .find(elms.quizResultsTimeValue)
            .text(
                totalSec > 0
                    ? this.formatDurationHuman(completionTimeSec)
                    : "0m 0s",
            );
        $finished
            .find(elms.quizResultsAnswersCorrectText)
            .text(`${correctCount} correct`);
        $finished
            .find(elms.quizResultsAnswersIncorrectText)
            .text(`${incorrectCount} incorrect`);
        let finishedSubtitle =
            this._data.store_page.extra_completion.subtitle_quiz;
        finishedSubtitle = finishedSubtitle.replace(
            "{extra_type}",
            this._selectedExtra.type,
        );
        $finished
            .find(elms.finishedSectionTitle)
            .first()
            .text(finishedSubtitle);

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionFinished);
        $btn.removeClass(c.isAnswering).prop("disabled", false);

        this._userAnswers[elms.quizSummaryMetaKey] = {
            completionTimeSec,
            totalPoints,
            correctCount,
            incorrectCount,
        };
    }

    gradeCurrentQuizQuestion() {
        const elms = this.elms;
        const c = this.classes;
        const idx = this._quizIndex;
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return;
        }
        const question = questions[idx];
        if (!question) {
            return;
        }

        const $body = this.getActiveModalBody();
        const $segment = this.findMultipleChoiceSegment($body, idx);
        const $selected = $segment.find(elms.segmentOptionSelected);
        if (!$selected.length) {
            return;
        }

        const answers = question.answers;
        const correctIndex = this.getQuizCorrectAnswerIndex(answers);
        const dataId = $selected.attr("data-id") || "";
        const selectedIndex = this.parseQuizOptionAnswerIndex(dataId);
        const correct =
            selectedIndex >= 0 &&
            correctIndex >= 0 &&
            selectedIndex === correctIndex;
        const scoreAwarded = correct
            ? Math.max(0, Number(question.score) || 0)
            : 0;

        this._userAnswers[idx] = {
            selectedIndex,
            correct,
            score: scoreAwarded,
        };

        $segment
            .find(elms.segmentOptions)
            .find(elms.segmentOption)
            .each((i, el) => {
                const $opt = $(el);
                $opt.addClass(i === correctIndex ? c.isCorrect : c.isIncorrect);
            });

        $segment.addClass(c.isAnswered);
        $(elms.fullscreenContinueButton).removeClass(c.isAnswering);
    }

    /**
     * Saves unanswered quiz entries as incorrect when timer expires.
     * If an option was selected but not confirmed, it is still stored as incorrect.
     */
    markRemainingQuizQuestionsIncorrect() {
        const elms = this.elms;
        const c = this.classes;
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }

        const $body = this.getActiveModalBody();
        questions.forEach((question, idx) => {
            if (this._userAnswers[idx]) {
                return;
            }

            const $segment = this.findMultipleChoiceSegment($body, idx);
            const $selected = $segment.find(elms.segmentOptionSelected);
            const selectedIndex = $selected.length
                ? this.parseQuizOptionAnswerIndex(
                      $selected.attr("data-id") || "",
                  )
                : -1;
            const correctIndex = this.getQuizCorrectAnswerIndex(
                question?.answers,
            );

            this._userAnswers[idx] = {
                selectedIndex,
                correct: false,
                score: 0,
            };

            $segment
                .find(elms.segmentOptions)
                .find(elms.segmentOption)
                .each((i, optEl) => {
                    const $opt = $(optEl);
                    $opt.addClass(
                        i === correctIndex ? c.isCorrect : c.isIncorrect,
                    );
                });
            $segment.addClass(c.isAnswered);
        });
    }

    /**
     * Ends quiz immediately on timeout and marks all remaining questions incorrect.
     */
    finalizeQuizOnTimeout() {
        if (this._selectedExtra?.type !== "quiz") {
            return;
        }
        if (
            $(this.elms.modalSections).hasClass(this.classes.isSectionFinished)
        ) {
            return;
        }
        this.markRemainingQuizQuestionsIncorrect();
        $(this.elms.fullscreenContinueButton).removeClass(
            this.classes.isAnswering,
        );
        this.showQuizFinishedSection();
    }

    /**
     * Clears the quiz timer interval without resetting elapsed/total (e.g. after quiz completion).
     */
    stopQuizCountdownIntervalOnly() {
        if (this._quizTimerIntervalId != null) {
            clearInterval(this._quizTimerIntervalId);
            this._quizTimerIntervalId = null;
        }
    }

    /**
     * Stop the quiz countdown interval and reset timer state (modal closed or flow reset).
     */
    clearQuizCountdown() {
        this.stopQuizCountdownIntervalOnly();
        this._quizTimerTotalSec = 0;
        this._quizTimerRemainingSec = 0;
        $(this.elms.modalProgressTrack).removeClass(this.classes.quizTimerLabelOutside);
    }

    /**
     * @param {string | number} timerMinutesStr Total duration in minutes (API string).
     */
    parseTimerMinutesToSeconds(timerMinutesStr) {
        const n = parseFloat(String(timerMinutesStr ?? "").replace(",", "."));
        if (!Number.isFinite(n) || n < 0) return 0;
        return Math.round(n * 60);
    }

    /**
     * @param {number} totalSeconds
     */
    formatSecondsToMmSs(totalSeconds) {
        const s = Math.max(0, Math.floor(totalSeconds));
        const mm = Math.floor(s / 60);
        const ss = s % 60;
        return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
    }

    /**
     * Human-readable duration for quiz results (e.g. `1m 48s`).
     * @param {number} totalSeconds
     * @returns {string}
     */
    formatDurationHuman(totalSeconds) {
        const s = Math.max(0, Math.floor(totalSeconds));
        const mm = Math.floor(s / 60);
        const ss = s % 60;
        if (mm === 0) {
            return `${ss}s`;
        }
        return `${mm}m ${ss}s`;
    }

    updateQuizProgressUI() {
        const elms = this.elms;
        const c = this.classes;
        const total = this._quizTimerTotalSec;
        const remaining = this._quizTimerRemainingSec;
        const pct = total > 0 ? (remaining / total) * 100 : 0;
        $(elms.modalProgressFill).attr("style", `width: ${pct}%;`);
        $(elms.modalProgressFillSpan).text(this.formatSecondsToMmSs(remaining));
        $(elms.modalProgressTrack).toggleClass(
            c.quizTimerLabelOutside,
            pct >= 0 && pct <= 50,
        );
    }

    /**
     * Shows remaining time as mm:ss and a fill width from 100% (full time) to 0%.
     * @param {string | number} timerMinutesStr Total duration in minutes (string from extra).
     */
    populateQuizProgress(timerMinutesStr) {
        this.clearQuizCountdown();
        const totalSec = this.parseTimerMinutesToSeconds(timerMinutesStr);
        this._quizTimerTotalSec = totalSec;
        this._quizTimerRemainingSec = totalSec;
        this.updateQuizProgressUI();
        if (totalSec <= 0) {
            this.finalizeQuizOnTimeout();
            return;
        }
        this._quizTimerIntervalId = setInterval(() => {
            this._quizTimerRemainingSec = Math.max(
                0,
                this._quizTimerRemainingSec - 1,
            );
            this.updateQuizProgressUI();
            if (this._quizTimerRemainingSec <= 0) {
                if (this._quizTimerIntervalId != null) {
                    clearInterval(this._quizTimerIntervalId);
                    this._quizTimerIntervalId = null;
                }
                this.finalizeQuizOnTimeout();
            }
        }, 1000);
    }

    populateQuizQuestion(questions) {
        const elms = this.elms;
        const c = this.classes;
        const $body = this.getActiveModalBody();

        if (!this._quizMcTemplate || !this._quizMcTemplate.length) {
            const $src = $body.find(elms.segmentMultipleChoiceTemplate).first();
            if (!$src.length) return;
            this._quizMcTemplate = $src
                .clone(true, true)
                .removeClass(c.isTemplate);
        }

        $body
            .find(elms.segmentMultipleChoice)
            .not(elms.isTemplateSelector)
            .remove();

        if (!Array.isArray(questions)) return;

        questions.forEach((question, idx) => {
            const $segment = this._quizMcTemplate.clone(true, true);
            $segment.attr(elms.attrQuestionIndex, String(idx));
            $segment
                .find(elms.segmentTitle)
                .text(String(question.question || ""));

            const $options = $segment.find(elms.segmentOptions);
            $options.empty();

            this.appendMcOptionList($options, {
                optionIdPrefix: "quiz_option",
                questionIndex: idx,
                answers: question.answers,
            });

            if (idx === 0) {
                $segment.addClass(c.isActive);
            }

            $body.append($segment);
        });
    }

    stopRaceCountUpIntervalOnly() {
        if (this._raceTimerIntervalId != null) {
            clearInterval(this._raceTimerIntervalId);
            this._raceTimerIntervalId = null;
        }
    }

    clearRaceCountUp() {
        this.stopRaceCountUpIntervalOnly();
        this._raceElapsedSec = 0;
        $(this.elms.raceTimerTime).text(this.formatSecondsToMmSs(0));
    }

    updateRaceTimerUI() {
        $(this.elms.raceTimerTime).text(
            this.formatSecondsToMmSs(this._raceElapsedSec),
        );
    }

    startRaceCountUp() {
        this.stopRaceCountUpIntervalOnly();
        this._raceElapsedSec = 0;
        this.updateRaceTimerUI();
        this._raceTimerIntervalId = setInterval(() => {
            this._raceElapsedSec += 1;
            this.updateRaceTimerUI();
        }, 1000);
    }

    /**
     * Enables/disables Bevestigen during race while `isAnswering` is active.
     */
    syncRaceBevestigenEnabled() {
        if (this._selectedExtra?.type !== "race") {
            return;
        }
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        if (!$btn.hasClass(c.isAnswering)) {
            $btn.prop("disabled", false);
            return;
        }
        const q = questions[this._raceIndex];
        if (!q) {
            return;
        }
        const $body = this.getActiveModalBody();
        if (q.type === "essay") {
            const $ta = $body
                .find(".segment-text-input")
                .not(elms.isTemplateSelector)
                .filter(`.${c.isActive}`)
                .find(elms.segmentTextareaField);
            const ok = String($ta.val() ?? "").trim().length > 0;
            $btn.prop("disabled", !ok);
            return;
        }
        const $segment = this.findMultipleChoiceSegment($body, this._raceIndex);
        const hasSel = $segment.find(elms.segmentOptionSelected).length > 0;
        $btn.prop("disabled", !hasSel);
    }

    /**
     * @param {unknown[]} questions
     */
    populateRaceQuestions(questions) {
        const elms = this.elms;
        const c = this.classes;
        const $body = this.getActiveModalBody();

        if (!this._raceMcTemplate || !this._raceMcTemplate.length) {
            const $mc = $body.find(elms.segmentMultipleChoiceTemplate).first();
            if (!$mc.length) {
                return;
            }
            this._raceMcTemplate = $mc
                .clone(true, true)
                .removeClass(c.isTemplate);
        }
        if (!this._raceTextTemplate || !this._raceTextTemplate.length) {
            const $tx = $body.find(elms.segmentTextInputTemplate).first();
            if (!$tx.length) {
                return;
            }
            this._raceTextTemplate = $tx
                .clone(true, true)
                .removeClass(c.isTemplate);
        }

        $body
            .find(elms.segmentMultipleChoice)
            .not(elms.isTemplateSelector)
            .remove();
        $body.find(".segment-text-input").not(elms.isTemplateSelector).remove();

        if (!Array.isArray(questions)) {
            return;
        }

        questions.forEach((raw, idx) => {
            const question =
                /** @type {{ type?: string, question?: string, answers?: Array<{ answer?: string }>, essay_answers?: Array<{ answer?: string }> }} */ (
                    raw
                );
            const qType = String(question?.type ?? "multiple");
            if (qType === "essay") {
                const $segment = this._raceTextTemplate.clone(true, true);
                $segment.attr(elms.attrQuestionIndex, String(idx));
                $segment
                    .find(elms.segmentTitle)
                    .text(String(question.question || ""));
                $segment.find(elms.segmentTextareaField).val("");
                if (idx === 0) {
                    $segment.addClass(c.isActive);
                }
                $body.append($segment);
            } else {
                const $segment = this._raceMcTemplate.clone(true, true);
                $segment.attr(elms.attrQuestionIndex, String(idx));
                $segment
                    .find(elms.segmentTitle)
                    .text(String(question.question || ""));

                const $options = $segment.find(elms.segmentOptions);
                $options.empty();

                this.appendMcOptionList($options, {
                    optionIdPrefix: "race_option",
                    questionIndex: idx,
                    answers: question.answers,
                });

                if (idx === 0) {
                    $segment.addClass(c.isActive);
                }
                $body.append($segment);
            }
        });
    }

    handleRaceStepsContinue() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const questions = this._questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            return;
        }

        if ($btn.hasClass(c.isAnswering)) {
            const q = questions[this._raceIndex];
            if (!q) {
                return;
            }
            if (String(q.type) === "essay") {
                if (this.commitCurrentRaceEssay()) {
                    this.advanceRaceUiAfterAnswerRecorded();
                }
                return;
            }
            if (this.recordRaceMcAnswer()) {
                this.advanceRaceUiAfterAnswerRecorded();
            }
            return;
        }
    }

    /**
     * Moves to the next race question or the finished screen (answer already stored in `_userAnswers`).
     */
    advanceRaceUiAfterAnswerRecorded() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return;
        }

        if (this._raceIndex < questions.length - 1) {
            this._raceIndex += 1;
            const $body = this.getActiveModalBody();
            $body
                .find(elms.modalSectionSegment)
                .not(elms.isTemplateSelector)
                .removeClass(c.isActive);
            $body
                .find(`[${elms.attrQuestionIndex}="${this._raceIndex}"]`)
                .addClass(c.isActive);
            $btn.addClass(c.isAnswering).prop("disabled", true);
            this.syncRaceBevestigenEnabled();
        } else {
            this.showRaceFinishedSection();
        }
    }

    /**
     * Records race MC answer (no correct/incorrect UI). Used with {@link advanceRaceUiAfterAnswerRecorded}.
     *
     * @returns {boolean}
     */
    recordRaceMcAnswer() {
        const elms = this.elms;
        const idx = this._raceIndex;
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return false;
        }
        const question = questions[idx];
        if (!question) {
            return false;
        }

        const $body = this.getActiveModalBody();
        const $segment = this.findMultipleChoiceSegment($body, idx);
        const $selected = $segment.find(elms.segmentOptionSelected);
        if (!$selected.length) {
            return false;
        }

        const answers = question.answers;
        const correctIndex = this.getQuizCorrectAnswerIndex(answers);
        const dataId = $selected.attr("data-id") || "";
        const selectedIndex = this.parseQuizOptionAnswerIndex(dataId);
        const correct =
            selectedIndex >= 0 &&
            correctIndex >= 0 &&
            selectedIndex === correctIndex;

        this._userAnswers[idx] = {
            selectedIndex,
            correct,
        };

        return true;
    }

    /**
     * @returns {boolean}
     */
    commitCurrentRaceEssay() {
        const elms = this.elms;
        const idx = this._raceIndex;
        const questions = this._questions;
        if (!Array.isArray(questions)) {
            return false;
        }
        const $body = this.getActiveModalBody();
        const $segment = $body.find(
            `.segment-text-input[${elms.attrQuestionIndex}="${idx}"]`,
        );
        const text = String(
            $segment.find(elms.segmentTextareaField).val() ?? "",
        ).trim();
        if (!text.length) {
            return false;
        }
        const question = questions[idx];
        const essayRows = question?.essay_answers;
        const allowed = Array.isArray(essayRows)
            ? essayRows
                  .map((row) => String(row?.answer ?? "").trim())
                  .filter((s) => s.length > 0)
            : [];
        const correct = allowed.some((a) => a === text);
        this._userAnswers[idx] = { text, correct };
        return true;
    }

    showRaceFinishedSection() {
        const elms = this.elms;
        const c = this.classes;
        const $btn = $(elms.fullscreenContinueButton);
        this.stopRaceCountUpIntervalOnly();

        const completionTimeSec = this._raceElapsedSec;
        const timeLabel = this.formatSecondsToMmSs(completionTimeSec);
        $(elms.raceResultsTime).text(timeLabel);
        $(elms.raceTimerTime).text(timeLabel);

        this._userAnswers[elms.raceSummaryMetaKey] = {
            completionTimeSec,
        };

        const $finished = $(elms.activityFullSectionFinished);
        let finishedSubtitle =
            this._data.store_page.extra_completion.subtitle_race;
        finishedSubtitle = finishedSubtitle.replace(
            "{extra_type}",
            this._selectedExtra.type,
        );
        $finished
            .find(elms.finishedSectionTitle)
            .first()
            .text(finishedSubtitle);

        $(elms.modalSections)
            .removeClass(c.sectionAll)
            .addClass(c.isSectionFinished);
        $btn.removeClass(c.isAnswering).prop("disabled", false);
    }
}
